import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('category.title')}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
          {t('category.subtitle')}
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-xl">
        <CategoryDropdown />
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <div className="relative h-36 w-full overflow-hidden sm:h-40">
              <img
                src={cat.image}
                alt={t(cat.nameKey)}
                title={`${t(cat.nameKey)} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              <span className="absolute bottom-2 left-2 flex h-7 w-7 items-center justify-center rounded-md bg-background-50/90 text-secondary-700">
                <i className={`${cat.icon} text-sm`} />
              </span>
            </div>
            <div className="flex items-center justify-between px-3 py-3">
              <span className="text-xs md:text-sm font-semibold text-foreground-900 leading-tight">
                {t(cat.nameKey)}
              </span>
              <i className="ri-arrow-right-up-line text-foreground-400 text-sm" />
            </div>
          </a>
        ))}
      </div>

      <div className="mt-10 text-center">
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          {t('category.browseAll')}
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}